import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
        <div className="nav-brand">
          <Logo />
        </div>
        
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About Us</a></li>
            <li><a href="#impact" onClick={() => setIsMenuOpen(false)}>Our Impact</a></li>
            <li className="dropdown">
              <a href="#help">How to Help <i className="fas fa-chevron-down"></i></a>
              <ul className="dropdown-menu">
                <li><a href="#donate">Donate</a></li>
                <li><a href="#volunteer">Volunteer</a></li>
                <li><a href="#sponsor">Sponsor a Student</a></li>
              </ul>
            </li>
            <li><a href="#stories" onClick={() => setIsMenuOpen(false)}>Stories</a></li>
            <li><Link to="/events" onClick={() => setIsMenuOpen(false)}>Events</Link></li>
            <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact Us</a></li>
          </ul>
        </nav>
        
        <a href="#donate" className="btn btn-primary btn-donate">Donate Now</a>
        
        <button 
          className={`mobile-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;